import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneInput } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'

interface IProps {
  required?: boolean
  defaultValue?: string
}

export const ConsigneeNameField: FC<IProps> = ({ required, defaultValue, ...args }) => {
  const { t } = useTranslation()
  return (
    <FormItem required={required} initialValue={defaultValue} name="provider_consignee_name" label={t('logistics.create.consigneeName')} rules={[{ required }]}>
      <OneInput disabled {...args} />
    </FormItem>
  )
}
